import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import toast from 'react-hot-toast'

export default function Login() {
  const { login } = useAuth()
  const navigate  = useNavigate()
  const [form, setForm]       = useState({ email: '', password: '' })
  const [cargando, setCargando] = useState(false)
  const [bloqueo, setBloqueo]   = useState(null) // { mensaje, linkPago } cuando la suscripción está vencida

  // Si el corte se detectó mientras alguien ya estaba trabajando (no al
  // loguearse), api.js lo dejó guardado acá antes de mandarnos para acá.
  useEffect(() => {
    const guardado = sessionStorage.getItem('pos_bloqueo_suscripcion')
    if (guardado) {
      sessionStorage.removeItem('pos_bloqueo_suscripcion')
      try {
        const payload = JSON.parse(guardado.replace('SUSCRIPCION_SUSPENDIDA::', ''))
        setBloqueo({ mensaje: payload.mensaje, linkPago: payload.link_pago || null })
      } catch {}
    }
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    if (!form.email || !form.password) { toast.error('Completa todos los campos'); return }
    setCargando(true)
    setBloqueo(null)
    try {
      await login(form.email, form.password)
      navigate('/pos')
    } catch (err) {
      const errorMsg = err?.response?.data?.error || ''
      if (errorMsg.startsWith('SUSCRIPCION_SUSPENDIDA::')) {
        try {
          const payload = JSON.parse(errorMsg.replace('SUSCRIPCION_SUSPENDIDA::', ''))
          setBloqueo({ mensaje: payload.mensaje, linkPago: payload.link_pago || null })
        } catch {
          setBloqueo({ mensaje: 'Tu suscripción a Redcaja está vencida.', linkPago: null })
        }
      }
      // Cualquier otro error (credenciales, etc.) ya lo muestra el interceptor con un toast
    } finally {
      setCargando(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        {bloqueo ? (
          <div style={{textAlign:'center', padding:'8px 4px'}}>
            <div style={{
              width:56, height:56, borderRadius:'50%', background:'var(--color-danger-bg)',
              display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 18px',
              fontSize:28,
            }}>🔒</div>
            <h2 style={{fontSize:19, marginBottom:8}}>Suscripción vencida</h2>
            <p style={{fontSize:14, color:'var(--color-muted)', lineHeight:1.5, marginBottom:24}}>
              {bloqueo.mensaje}
            </p>

            {bloqueo.linkPago ? (
              <a href={bloqueo.linkPago} target="_blank" rel="noreferrer"
                className="btn btn-primary btn-lg btn-block" style={{textDecoration:'none'}}>
                💳 Pagar ahora
              </a>
            ) : (
              <div style={{fontSize:13, color:'var(--color-hint)', background:'var(--color-bg)',
                borderRadius:8, padding:'12px 14px'}}>
                No pudimos generar el link de pago automáticamente. Contacta a soporte para regularizar tu cuenta.
              </div>
            )}

            <button className="btn btn-secondary btn-block" style={{marginTop:12}}
              onClick={()=>{ setBloqueo(null); setForm({ email:'', password:'' }) }}>
              Volver
            </button>
          </div>
        ) : (
          <>
            <div className="login-logo">
              <div className="logo-box"><img src="/logo-redcaja.png" alt="Redcaja"/></div>
              <h1>Redcaja</h1>
              <p>Tu negocio bajo control, desde cualquier pantalla</p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Correo electrónico</label>
                <input className="form-input" type="email" placeholder="usuario@empresa.cl"
                  value={form.email} onChange={e => setForm({...form, email: e.target.value})} autoFocus/>
              </div>
              <div className="form-group">
                <label className="form-label">Contraseña</label>
                <input className="form-input" type="password" placeholder="••••••••"
                  value={form.password} onChange={e => setForm({...form, password: e.target.value})}/>
              </div>
              <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={cargando}>
                {cargando ? <span className="spinner"/> : 'Iniciar sesión'}
              </button>
            </form>

            <p style={{textAlign:'center',marginTop:20,fontSize:12,color:'var(--color-hint)'}}>
              Redcaja — Sistema de punto de venta en la nube
            </p>
          </>
        )}
      </div>
    </div>
  )
}
